module.exports = __webpack_public_path__ + "static/media/avatar.fb8a8c1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.jpg
// module id = 141
// module chunks = 0